import { styled } from "styled-components";

export const InfoImage = styled.div`
  height: 100%;
  width: 100%;
  background: url(${(props) => props.$background_image})
    ${(props) => props.$background_image_details};
  background-size: cover;
`;
